// ─────────────────────────────────────────────────────────────────────────────
// ProtectedRoute.js — Guards routes that require authentication
//
// Guards on the stored TOKEN (TokenStorage.get), not on the user object shape.
// This means:
//   - A valid login always grants access, even if the backend response didn't
//     include a user object that could be fully normalised.
//   - The only way to lose access is for the token to be cleared
//     (logout, or a 401 response triggering the "auth:expired" event in api.js).
// ─────────────────────────────────────────────────────────────────────────────
import { Navigate } from "react-router-dom";
import { TokenStorage } from "../services/api";

export default function ProtectedRoute({ children }) {
  // Token is the source of truth — it's set immediately on login and cleared
  // on logout / session expiry.
  const isAuthenticated = !!TokenStorage.get();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
